import axios from 'axios';

export interface EnhancedBlog {
  id: string;
  title: string;
  slug: string;
  content: string;
  excerpt: string;
  featuredImage: string;
  authorName: string;
  authorAvatar: string;
  authorBio: string;
  category: string;
  tags: string[];
  status: 'draft' | 'published' | 'archived';
  publishedAt: string;
  readTime: number;
  views: number;
  likes: number;
  metaTitle: string;
  metaDescription: string;
  keywords: string[];
}

export interface BlogResponse {
  blogs: EnhancedBlog[];
  total: number;
  pages: number;
  currentPage: number;
}

class EnhancedBlogService {
  private baseURL = '/api/enhanced-blog';

  async getBlogs(page = 1, limit = 10, category?: string, search?: string): Promise<BlogResponse> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    
    if (category) params.append('category', category);
    if (search) params.append('search', search);
    
    const response = await axios.get(`${this.baseURL}?${params}`);
    return response.data;
  }

  async getBlogBySlug(slug: string): Promise<EnhancedBlog> {
    const response = await axios.get(`${this.baseURL}/${slug}`);
    return response.data;
  }

  async createBlog(blogData: Partial<EnhancedBlog>): Promise<EnhancedBlog> {
    const response = await axios.post(`${this.baseURL}/admin`, blogData);
    return response.data;
  }

  async updateBlog(id: string, blogData: Partial<EnhancedBlog>): Promise<EnhancedBlog> {
    const response = await axios.put(`${this.baseURL}/admin/${id}`, blogData);
    return response.data;
  }

  async deleteBlog(id: string): Promise<void> {
    await axios.delete(`${this.baseURL}/admin/${id}`);
  }
}

export default new EnhancedBlogService();
